module.exports = __webpack_public_path__ + "assets/img/yyCare_d_p2.af96a933.png";